<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tab-container px-6 pt-6 minus-top">
        <div class="tab-text">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                v-validate ="'required'"
                type ='text'
                name ='website'
                :label = "$t('adminWs.nameWs')"
                autocomplete ="off"
                class="w-full"
                v-model="form.name"
                data-vv-validate-on="blur"
              ></vs-input>
              <span class="text-danger text-sm">{{
                errors.first("website")
              }}</span>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                :disabled="!isAdmin && isUpdate"
                v-validate ="'required|url'"
                type ='text'
                name ='url'
                :label = "$t('adminWs.path')"
                autocomplete ="off"
                class="w-full"
                v-model="form.url"
                data-vv-validate-on="blur"
              ></vs-input>
              <span class="text-danger text-sm">
                {{errors.first("url")}}
              </span>

            </div>

             <div v-if = "isAdmin" class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              v-model="form.categoryArticleId"
              :label="$t('adminWs.catalogCode')"
              class="w-full"
              name="category"
              >
                  <vs-select-item
                  v-for="(optional,indexCate)  in dataCategoryId"
                  :key="indexCate"
                  :value="optional.id"
                  :text="optional.name"
                  >
                  </vs-select-item>
              </vs-select>
              <span class="text-danger text-sm">
                {{errors.first("category")}}
              </span>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-select

              :disabled="!isAdmin && isUpdate"
              v-model="form.type"
              :label="$t('adminWs.type')"
              class="w-full"
              name="groups"
              >
                  <vs-select-item
                  v-for="(optional,indexGroup)  in optionalGroup"
                  :key="indexGroup"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
            </div>

            <div v-if = "isAdmin" class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              v-model="form.status"
              :label="$t('adminWs.status')"
              class="w-full"
              name="status"
              >
                  <vs-select-item
                  v-for="(optional,indexStatus)  in optionalStatus"
                  :key="indexStatus"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
            </div>

             <div v-if = "isAdmin" class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              v-model="form.processStatus"
              :label="$t('adminWs.status')"
              class="w-full"
              name="processsStatus"
              >
                  <vs-select-item
                  v-for="(optional,indexType)  in optionalProcessStatus"
                  :key="indexType"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
            </div>

            <div v-if = "isAdmin" class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                type ='text'
                name ='fullAddress'
                :label="$t('adminWs.address')"
                autocomplete ="off"
                class="w-full"
                v-model="form.domain"
                data-vv-validate-on="blur"
              ></vs-input>
              <span class="text-danger text-sm">
                {{errors.first("fullAddress")}}
              </span>
            </div>

            <div v-if = "isAdmin" class="vx-col md:w-1/2 w-full mt-2">
              <vs-textarea
                type ='text'
                name ='config'
                :label="$t('adminWs.configuration')"
                autocomplete ="off"
                class="w-full"
                v-model="form.config"
              ></vs-textarea>
            </div>

          </div>
           <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 text-size" @click="saveChanges" :disabled ="!validateForm">{{`${isUpdate ?
                  $t('adminWs.update'): $t('adminWs.create')}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2 text-size" type="border" color="warning" @click="$router.go(-1)">{{$t('adminWs.back')}}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components:{
    VueTagsInput
  },
  data(){
      return {
    isUpdate:false,
    isAdmin: false,
    form :
        {
         name: null,
         domain: null,
         config:null,
         categoryArticleId:null,
         type: null,
         url: '',
         status: "1",
         processStatus:null
        }
      ,
      optionalStatus:[
        {text:'Hoạt động',value:1},
        {text:'Không hoạt động',value:0}
      ],
      optionalGroup:[
        {text:'Báo chí',value:1},
        {text:'Tin tức',value:2},
        {text:'Blog', value:3},
        {text:'Forum', value:4}
      ],
      optionalProcessStatus: [
        {text:'Đã tiếp nhận',value:0},
        {text:'Đã xử lý',value:1},
        {text:'Sẵn sàng',value:2},
        {text:'Đang rà quét',value:3}
      ],
      data:{},
      validation:[
        {
          classes: 'min-length',
          rule: tag => tag.text.length < 8
        },
        {
          classes: 'no-numbers',
          rule: /^([^0-9]*)$/
        },
        {
          classes: 'avoid-item',
          rule:/^(?!Cannot).*$/,
          disableAdd:true
        },
        {
          classes :'no-braces',
          rule: ({text}) => text.indexOf('{') !== -1 || text.indexOf('}') !== -1
        }
      ],
      tags:[],
      dataCategoryId:[],
      }
  },
  computed:{
      validateForm(){
          return !this.errors.any();
      }
  },
  watch:{

  },
  created(){
    this.initScreen();
    this.$eventBus.$on('i18n', (event) => {
      this.checkOptionalStatus();
      this.checkOptionalGroup();
      this.checkProcessStatus();
    })
    this.checkOptionalStatus();
    this.checkOptionalGroup();
    this.checkProcessStatus();

  },
  methods:{
    checkOptionalStatus : function (){
      this.optionalStatus[0].text = this.$t('adminWs.active')
      this.optionalStatus[1].text = this.$t('adminWs.inactive')
    },
    checkOptionalGroup : function () {
      this.optionalGroup[0].text = this.$t('adminWs.newspapers')
      this.optionalGroup[1].text = this.$t('adminWs.news')
    },
    checkProcessStatus : function (){
      this.optionalProcessStatus[0].text = this.$t('adminWs.received')
      this.optionalProcessStatus[1].text = this.$t('adminWs.processed')
      this.optionalProcessStatus[2].text = this.$t('adminWs.ready')
      this.optionalProcessStatus[3].text = this.$t('adminWs.scanning')

    },
    checkValidJson(value){
      // temporary not check
      return true;
      if (!value) return true;
      try {
        JSON.parse(value);
      } catch (error) {
        return false;
      }
      return true;
    },
    searchWebsiteById(that){
        const payload ={
            categoryArticleId:this.form.categoryArticleId
        };
        return new Promise(function(resolve,reject){
          that.$processor.post('/website/all',payload).then((response) =>{
            resolve(response.data);
          }).catch((err) =>{
            reject(err);
          })
        })
    },
    checkWebsiteExited(value){
      return new Set(value).size !== value.length;
    },
    initScreen(){
      this.getCategoryId();
      let role = JSON.parse(localStorage.userInfo).userRole
      this.isAdmin = role == "admin";
      this.form.id = this.$route.query.id;
      const payload = {
        id : parseInt(this.form.id)
      };
      if(this.form.id){
        this.$processor.post('/website/find-by-id',payload).then((response) =>{
        this.data = response.data;
        this.form.name= this.data.name;
        this.form.url = this.data.url;
        this.form.categoryArticleId = this.data.categoryArticleId;
        this.form.config = this.data.config;
        this.form.domain= this.data.domain;
        this.form.type = this.data.type;
        this.form.status = this.data.status;
        this.form.processStatus = this.data.processStatus;
        this.isUpdate = true;
        }).catch((err) =>{
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        })
      }
    },
    async saveChanges(event){
        event.preventDefault();
        if(!this.validateForm) return;
        const result = await this.$validator.validateAll();
        if (!result) return;
        let checkValidJson = this.checkValidJson(this.form.config);

        if(!checkValidJson){
          return this.$vs.notify({
            text:'Dữ liệu config là Json',
            icon:'icon-alert-circle',
            color:'danger',
            iconPack:'feather'
          })
        }
        this.$vs.loading();

        let path = this.isUpdate ? '/website/update' : '/website/create';
        this.form.id = this.$route.query.id;
        const payloadCreate =[{
            categoryArticleId:this.form.categoryArticleId,
            config:this.form.config,
            domain:this.form.domain,
            type:this.form.type,
            name:this.form.name,
            status:this.form.status === undefined ? 1 : this.form.status,
            url:this.form.url,
            processStatus: this.form.processStatus,
            userIds: []
        }];
        const payloadUpdate = [
          {
            id:this.form.id,
            categoryArticleId:this.form.categoryArticleId,
            config:this.form.config,
            domain:this.form.domain,
            type:this.form.type,
            name:this.form.name,
            status:this.form.status,
            url:this.form.url,
            processStatus: this.form.processStatus,
            userIds: []
          }
        ];
        let payload = this.isUpdate ? payloadUpdate:payloadCreate;
        this.$processor.post(path,payload).then((response) =>{
          this.data = response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            text: ` ${this.isUpdate ? this.$t('adminWs.update') : this.$t('adminWs.create')} ` + this.$t('adminWs.textFooter') ,
            color:'primary',
            icon:'icon-alert-circle',
            iconPack:'feather'
          });
          this.$router.push('/page/website/manage').catch(() =>{})
        }).catch((err) =>{
           this.$vs.loading.close();
            return this.$vs.notify({
               text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
    },
    getCategoryId:function(){
      this.$processor.get('/category-news/all').then((response) =>{
          this.dataCategoryId = response.data.content;
      })
    }
  }
}
</script>
<style scoped>
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.minus-top{
  margin-top: -24px;
}
</style>
